module.exports = __webpack_public_path__ + "media/images/global/icons/camera-25973db54a15b4e514c241423c9fe306.svg";